import { Theme, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, FC } from 'react';

type Direction = 'horizontal' | 'vertical';

type WbSpacerProps = {
  className?: string;
  style?: CSSProperties;
  direction?: Direction;
  spacing?: number;
};

const useStyles = makeStyles<Theme, { direction: Direction; spacing: number }>(
  theme => ({
    root: ({ spacing, direction }) => ({
      display: 'inline-block',
      width: direction === 'horizontal' ? theme.spacing(spacing) : undefined,
      minWidth: direction === 'horizontal' ? theme.spacing(spacing) : undefined,
      height: direction === 'vertical' ? theme.spacing(spacing) : undefined,
      minHeight: direction === 'vertical' ? theme.spacing(spacing) : undefined,
    }),
  }),
  { name: 'WbSpacer' },
);

export const WbSpacer: FC<WbSpacerProps> = ({
  className,
  style,
  direction = 'vertical',
  spacing = 1,
}) => {
  const classes = useStyles({ direction, spacing });
  return <span className={clsx(className, classes.root)} style={style} />;
};
